import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { IconPlus } from '../../../../shared/components/icons/IconPlus'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useGetTrademarkListQuery } from '../../../../app/api'
import { TrademarkCard } from './TrademarkCard'
import { Preloader } from '../../../../shared/components/cards/preloader/Preloader'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import { setModal } from '../../../../app/store/reducers/AppSlice'
import { AddTrademarkModal } from './AddTrademarkModal'
import { Tooltip } from 'antd'
import { TrademarkMissingStub } from '../../../../lib/widgets/stubs/TrademarkMissingStub'
import { StubLayout } from '../../../../lib/widgets/stubs/StubLayout'

export const ProjectTrademarks = () => {
  const { t } = useTranslation()
  const { id } = useParams()
  const dispatch = useAppDispatch()

  const projectId = Number(id)

  const { data, isLoading } = useGetTrademarkListQuery({ projectId: id as unknown as number })

  const canAdd = !data?.data?.find((row) => row.status === 'active')
  const hasTrademarks = !!data?.data?.length

  if (isLoading) {
    return <Preloader />
  }

  return (
    <div className={'grid h-full grid-rows-[auto_1fr_auto] items-start pt-[24px]'}>
      {hasTrademarks && (
        <div
          className={
            'flex min-h-[40px] flex-wrap items-center justify-between gap-[16px] md:flex-nowrap'
          }
        >
          <p className={'md:order-0 order-1 max-w-[600px] text-[13px] text-focus-500'}>
            {t('pages.project.trademarkDescription')}
          </p>

          <div className={'order-0 md:order-1'}>
            <Tooltip
              title={
                canAdd
                  ? null
                  : 'One active trademark per project allowed. Archive the current trademark to create a new one.'
              }
            >
              <div>
                <BpButton
                  className={'uppercase'}
                  disabled={!canAdd}
                  iconLeft={<IconPlus />}
                  theme={'default'}
                  onClick={() => {
                    if (!projectId) return

                    dispatch(
                      setModal({
                        children: (
                          <AddTrademarkModal
                            data={{
                              project_id: projectId,
                            }}
                          />
                        ),
                      }),
                    )
                  }}
                >
                  {t('pages.project.addTrademark')}
                </BpButton>
              </div>
            </Tooltip>
          </div>
        </div>
      )}

      {hasTrademarks ? (
        data?.data?.map((row: any) => (
          <div key={row.id}>
            <TrademarkCard projectId={projectId} trademarkId={row.id} />
          </div>
        ))
      ) : (
        <StubLayout gap={24}>
          <TrademarkMissingStub project={String(projectId)} />
        </StubLayout>
      )}
    </div>
  )
}
